<template>
  <div id="tracking-user">
    <v-layout align-start justify-start row fill-height>
      <v-flex xs12 sm12 md9 lg6>
        <p class="text-description mb-5">
          Tracking number - This is the ID of your parcel. You will receive it from the online store.
          It does not contain hyphens, dashes or other special characters.
          It usually looks like this: 9405509699938860829083. In addition to numbers,
          the track number may have one or more letters: TBA094490876000.
        </p>
        <v-form ref="form" v-model="valid" lazy-validatio>
          <div class="filter-label-text pb-2 mb-2 input-your-tracking">Input your tracking number</div>
          <v-text-field
            name="tracking"
            label="Tracking number"
            type="text"
            :error-messages="messages.tracking"
            @input="messages.tracking = null"
            :rules="trackingRules"
            required
            v-model="tracking"
            class="text-field-sign-in mb-4 pb-4"
            flat
            full-width
          >
          </v-text-field>


        </v-form>

        <v-layout row fill-height
                  :class="{
                  'align-start justify-start': $vuetify.breakpoint.mdAndUp,
                  'align-center justify-center': !$vuetify.breakpoint.mdAndUp
                  }" >
          <v-btn
            class="next-step-btn text-capitalize tracking-user tracking-search-user ml-0"
            color="#0E97FF"
            @click="onSearch"
            :loading="loading"
            :disabled="!valid || loading"
          >
            <span>Search Order</span>
          </v-btn>
        </v-layout>
        <div class="text-description-tracking mt-4 rectangle-tracking-user text-xs-center align-center justify-center ">
          <div
            class="mx-4">
              <span class="text-description-grey ">
              Do not specify in this field the order number, which looks like this: ORDER #108-9223429-1685032 (Amazon) or so: Item number 112122004175 (ebay).
              </span>

          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
    import Tracking from '@/services/Tracking'

    export default {
    name: "Trackings",
    data() {
      return {
        tracking: null,
        messages: [],
        valid: false
      }
    },
    computed: {
      loading() {
        return this.$store.getters.loading
      },
      trackingRules() {
        return [
          v => !!v || 'Tracking number is required',
          v => (v && v.length >= 6) || 'Tracking must be equal or than 10 characters',
        ]
      }
    },
    methods: {
      onSearch() {
        if (this.$refs.form.validate() && this.valid) {
          this.$store.commit('clearError')
          this.$store.commit('setLoading', true)

          Tracking.getHistoryForUser(this.tracking)
            .then(response => {
              this.$store.dispatch('setTracking', {id: this.tracking, history: response.data.data.history})
              this.$store.commit('setLoading', false)
              this.$router.push('/user-tracking/' + this.tracking)
            })
            .catch(error => {
              this.$store.commit('setLoading', false)
              if (error.response.status === this.$response.NotFound || error.response.status === this.$response.Conflict || error.response.status === this.$response.UnprocessableEntity) {
                this.$store.commit('setError', error.response.data.message)
              }
            })
        }
      }
    }

  }
</script>

<style scoped lang="stylus">
  .tracking-search-user span
    color #ffffff

  .tracking-user
    border-radius 6px
    min-width 15em
    height: 52px !important;


  .rectangle-tracking-user
    border-radius 6px
    background-color #FFF5DC
    padding 10px
    align-content center

  .track-a-package
    color #252A30
    font-family Roboto
    font-size 24px
    font-weight bold
    line-height 28px

  .input-your-tracking
    color #252A30
    font-size 14px
    font-weight 500
    line-height 18px
    margin-bottom 0

  .text-description-grey
    font-size 14px
    font-weight 500
    line-height 20px
</style>
